import { render } from "./appeals.widget.wp.vue?vue&type=template&id=43c5c804"
import script from "./appeals.widget.wp.vue?vue&type=script&lang=js"
export * from "./appeals.widget.wp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__